module.exports = __webpack_public_path__ + "img/vipUserIcon1.a8fcc04e.png";